import config from 'config';
import createAxiosInstance from './createAxisInstance';
import { CancelToken } from 'axios';
import { get } from 'lodash';
import { getStore } from 'configureStore';
import { push } from 'redux-little-router';
import { routeMap } from 'router';
import { transformRequestOptions } from 'utils/requestParamsSerializers/requestParamsSerializers';

const axiosInstance = createAxiosInstance;

export const LK_USE_CACHE_PROP = 'LK_USE_CACHE_PROP';

export default class API {
  static baseUrl = config.apiBaseUrl;

  /**
   * @param {'GET'|'PUT'|'POST'|'DELETE'} method
   * @param {string} url
   * @param {object} [params]
   * @param {string} [responseType]
   * @param {object} [data]
   * @param {object} [headers]
   * @param {function} [mapper]
   * @param {bool} [cancelable]
   * @param {function} [paramsSerializer]
   * @returns {AxiosPromise}
   */
  static request(
    {
      method,
      url,
      params,
      responseType = 'json',
      data,
      headers,
      paramsSerializer = transformRequestOptions,
      mapper = (data) => data,
      isKeepCache = false,
    },
    cancelable,
  ) {
    let cancel = null;
    const request = axiosInstance({
      method,
      url: `${API.baseUrl}${url}`,
      params,
      data,
      responseType,
      headers,
      paramsSerializer,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
      [LK_USE_CACHE_PROP]: isKeepCache,
    }).then((response) => {
      if (response.isOk) {
        return { ...response, data: mapper(response.data) };
      } else {
        if (get(response, 'error.response.data.errorType') === 'isDemo') {
          getStore().dispatch(
            push({
              pathname: routeMap.error,
              query: {
                title: 'Функционал недоступен',
                message:
                  'В демонстрационном режиме данный функционал недоступен. Для его использования Вы можете авторизоваться в полной версии личного кабинета ФЛ.',
                backPage: window.location,
              },
            }),
          );
        }
        return response;
      }
    });
    return cancelable ? { cancel, request } : request;
  }
}

export function downloadPdf(url) {
  return axiosInstance({
    method: 'GET',
    url,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',
  });
}

export function downloadPdfService(pdf, params = {}, url) {
  return axiosInstance({
    method: 'GET',
    url: url ? url : `${config.apiBaseUrl}/pdf/${pdf}`,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    params,
    responseType: params.isHtml ? 'text/html' : 'arraybuffer',
  });
}

export function downloadReceipt(data) {
  return axiosInstance({
    method: 'POST',
    url: `${config.apiBaseUrl}/pdf/receipt`,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    data,
    responseType: 'arraybuffer',
  });
}

export function downloadFileService(fileName, inn, cancelObj = {}) {
  return axiosInstance({
    method: 'GET',
    url: encodeURI(`${config.apiBaseUrl}/download/${inn}?filename=${fileName}`),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',

    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      cancelObj[fileName] = c;
    }),
  });
}

export function getReceiptsFileLink(data) {
  return axiosInstance({
    method: 'POST',
    data,
    url: `${config.apiBaseUrl}/pdf/receiptIds`,
  });
}

export function getConfig() {
  return axiosInstance({
    method: 'GET',
    url: `${config.apiBaseUrl}/taxpayer/config`,
  });
}

export function getAppIsReadyCheck() {
  return axiosInstance({
    method: 'GET',
    url: `${config.apiBaseUrl}/appStatus`,
  });
}
